export const ROLES = {
  G_ADMIN: 'G_Admin',
  H_ADMIN: 'H_Admin',
  S_ADMIN: 'S_Admin',
  USER: 'User',
  USER_TV: 'User_TV',
  USER_DEPLOY: 'User_Deploy',
  ORCHESTRA_SUPPORT: 'Orchestra_Support',
  D_ADMIN: 'D_Admin',
  NURSE: 'Nurse',
  NURSING_ASSISTANT: 'Nursing_Assistant',
};

export const ORCHESTRA_ROLE_HIERARCHY = [
  's_admin',
  'user_deploy',
  'orchestra_support',
  'g_admin',
  'h_admin',
  'user',
  'user_tv',
];

export function normalizeOrchestraRole(role) {
  if (!role || typeof role !== 'string') return '';
  return role.trim().toLowerCase();
}

export function getOrchestraRoleRank(role) {
  const normalized = normalizeOrchestraRole(role);
  if (!normalized) return -1;
  return ORCHESTRA_ROLE_HIERARCHY.indexOf(normalized);
}

export function canManageOrchestraRole(loggedRole, targetRole) {
  if (!targetRole) return true;

  const loggedRank = getOrchestraRoleRank(loggedRole);
  const targetRank = getOrchestraRoleRank(targetRole);

  if (loggedRank === -1 || targetRank === -1) return false;

  return loggedRank <= targetRank;
}
